import React from 'react'
import { Button, Card, Grid, Note, Spacer, Text } from '@geist-ui/react'

function formatAddress(record) {
  return record.display_address || record.account_address || 'Unknown address'
}

export default function ClaimEnrollmentPrompt({
  unclaimed,
  claimedByOther = [],
  onClaim,
  isLinking,
  attemptInfo,
  title,
  description,
  variant = 'standalone',
  showSupportNote = true,
}) {
  const throttled = attemptInfo?.throttled
  const remaining = attemptInfo?.remaining
  const heading = title || 'Claim your enrollment'
  const intro =
    description ||
    'We found active WaterPro enrollments that match your account. Select the correct address below to link it to your profile.'

  const containerStyle =
    variant === 'inline'
      ? {
          marginTop: '0',
          maxWidth: '100%',
          marginLeft: 0,
          marginRight: 0,
        }
      : {
          marginTop: '6rem',
          maxWidth: '600px',
          marginLeft: 'auto',
          marginRight: 'auto',
        }

  return (
    <Card shadow style={containerStyle}>
      <Text h3 style={{ textAlign: variant === 'inline' ? 'left' : 'center' }}>
        {heading}
      </Text>
      <Text p style={{ textAlign: variant === 'inline' ? 'left' : 'center' }}>
        {intro}
      </Text>

      <Spacer y={0.5} />

      {unclaimed.map((record) => (
        <Card
          key={`${record.account_id}-${record.account_address}`}
          style={{ marginBottom: '1rem' }}
        >
          <Grid.Container gap={1} alignItems="center">
            <Grid xs={18} sm={18} md={18}>
              <div>
                <Text h4 style={{ marginBottom: '0.25rem' }}>
                  {formatAddress(record)}
                </Text>
                <Text small style={{ marginBottom: '0', color: '#666' }}>
                  Account ID: {record.account_id}
                </Text>
              </div>
            </Grid>
            <Grid xs={6} sm={6} md={6} justify="flex-end">
              <Button
                auto
                type="success"
                disabled={throttled || isLinking}
                loading={isLinking}
                onClick={() => onClaim(record.account_address)}
              >
                Claim this enrollment
              </Button>
            </Grid>
          </Grid.Container>
        </Card>
      ))}

      {unclaimed.length === 0 && (
        <Note type="secondary">
          We did not find an unclaimed enrollment for this account. If you
          believe this is an error, please reach out to support.
        </Note>
      )}

      <Spacer y={0.75} />

      {claimedByOther.length > 0 && (
        <>
          <Note
            type="warning"
            label="Heads up"
            style={{ marginBottom: '0.75rem' }}
          >
            We found {claimedByOther.length}{' '}
            {claimedByOther.length === 1 ? 'enrollment' : 'enrollments'} already
            linked to another WaterPro user. If you need help reclaiming access,
            contact support.
          </Note>
        </>
      )}

      {throttled && (
        <Note type="error" style={{ marginBottom: '0.75rem' }}>
          You have reached the maximum number of linking attempts. Please try
          again later.
        </Note>
      )}

      {!throttled && typeof remaining === 'number' && (
        <Note type="secondary">
          {remaining} linking attempt{remaining === 1 ? '' : 's'} remaining in
          this window.
        </Note>
      )}

      <Spacer y={0.75} />

      {showSupportNote && (
        <Note type="secondary">
          Need help? Reach us at <strong>888-977-7481</strong> or{' '}
          <strong>info@waterproplan.com</strong>.
        </Note>
      )}
    </Card>
  )
}
